import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconChevronRight = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.7072 7.29297L14.7072 11.293C15.0977 11.6835 15.0977 12.3167 14.7072 12.7072L10.7072 16.7072L9.29297 15.293L12.5859 12.0001L9.29297 8.70718L10.7072 7.29297Z"
        />
      </svg>
    );
  }
);
